
import { mapMutations } from 'vuex';
export default {
  name: 'App',
  created() {
    this.INIT_ENV();
  },
  methods: {
    ...mapMutations(['INIT_ENV'])
  }
};
